import React from 'react'
import { Route, Routes } from 'react-router-dom'
import About from "../Components/About/About"
import Home from '../Components/Home/Hero'
import Project from '../Components/Project/Project'
import Services from '../Components/Services/services'
import Contact from '../Components/Contacts/Contact'
// import  {ThemeProvider} from "../Theme/ThemeContext"
function AllRouter() {
    return (
        <>
          
            <Routes>
                <>
                    <Route path='/about' element={<About />} />
                    <Route path='/' element={<Home />} />
                    <Route path='/projects' element={<Project />} />
                    <Route path='/services' element={<Services />} />
                    <Route path='/contact' element={<Contact />} />
                    <Route path='/*' element={<Home />} />

                </>

            </Routes>
         
        </>


    )
}

export default AllRouter